module.exports = __webpack_public_path__ + "img/mp-solution-icon-8.6fcc4ded.png";